import * as React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import { Button } from '../styles';
import { Input } from '../../../../Form/styles';
import Portal from '../../../../Portal';
import Popup, { PopupTheme } from '../../../../Popup';
import { PopupBody, PopupInputWrapper, PopupInputLabel } from '../styles';
import { renameTheme } from '../../../../../containers/Editor/actions';
import { ThemesState } from '../../../../../containers/Editor/reducer';

interface RenameThemeProps {
	themeId: string;
	themes: ThemesState;
	dispatch: Dispatch<StoreState>;
	className?: string;
}

const RenameTheme = ({ themeId, themes, className, dispatch }: RenameThemeProps) => {
	const { name: initialName } = themes[themeId];
	const [name, setName] = React.useState(initialName);
	const [error, setError] = React.useState<string | null>(null);
	const [isPopupDisplayed, setIsPopupDisplayed] = React.useState(false);

	const handleButtonClick = () => {
		setInitialState();
		setIsPopupDisplayed(true);
	};

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setName(e.target.value);
		setError(null);
	};

	const handleConfirm = () => {
		if (!name) {
			return;
		}

		if (name === initialName) {
			return setIsPopupDisplayed(false);
		}

		const usedThemeNames = Object.values(themes).map(({ name }) => name);

		if (usedThemeNames.includes(name)) {
			return setError('error.duplicate_theme');
		}

		setIsPopupDisplayed(false);
		dispatch(renameTheme(themeId, name));
		setInitialState();
	};

	const setInitialState = () => {
		setName(initialName);
		setError(null);
	};

	return (
		<>
			<Button onClick={handleButtonClick}>
				<Translate value="messages.rename" />
			</Button>
			<Portal parentNode={document.body}>
				<Popup
					className={`prevent-drag ${className || ''}`}
					isDisplayed={isPopupDisplayed}
					label={I18n.t('messages.rename_theme')}
					theme={PopupTheme.DARK}
					isConfirmDisabled={!name || !!error}
					onConfirm={handleConfirm}
					onCancel={() => setIsPopupDisplayed(false)}
				>
					<PopupBody>
						<PopupInputWrapper isError={!!error}>
							<PopupInputLabel value={error || 'messages.theme_name'} />
							<Input
								type="text"
								value={name}
								onChange={handleInputChange}
							/>
						</PopupInputWrapper>
					</PopupBody>
				</Popup>
			</Portal>
		</>
	);
};

export default RenameTheme;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/RenameTheme/index.tsx